import { useState } from 'react'
import { CriteriaFile } from '../../domain/CriteriaFile'
import { AxiosCriteriaFileRepository } from '../../infrastructure/AxiosCriteriaFileRepository'
import { DownloadCriteriaFileUseCase } from '../../usecases/DownloadCriteriaFileUseCase'

const saveFile = ({ blob, filename }: CriteriaFile) => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
}

export const useDownloadCriteriaFile = (
    groupId: number,
    criteriaId: number
) => {
    const [isDownloading, setIsDownloading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const download = async () => {
        if (isDownloading) return
        setIsDownloading(true)
        setError(null)
        try {
            const repository = new AxiosCriteriaFileRepository()
            const useCase = new DownloadCriteriaFileUseCase(repository)
            const criteriaFile = await useCase.execute(groupId, criteriaId)
            saveFile(criteriaFile)
        } catch (err) {
            setError(
                err instanceof Error
                    ? err.message
                    : 'Error al descargar el archivo del criterio'
            )
        } finally {
            setIsDownloading(false)
        }
    }

    return {
        download,
        isDownloading,
        error,
    }
}
